const RomaniaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112214)">
      <path
        d="M26.9563 1.24391C24.7896 0.440078 22.4462 1.03982e-08 19.9998 1.03982e-08C17.5534 -7.81146e-05 15.21 0.440078 13.0433 1.24391L11.3042 19.9999L13.0433 38.7559C15.2099 39.56 17.5533 40 19.9998 40C22.4462 40 24.7897 39.56 26.9563 38.7559L28.6954 20L26.9563 1.24391Z"
        fill="#FFDA44"
      />
      <path
        d="M40.0001 20.0011C40.0001 11.4019 34.5726 4.0709 26.9565 1.24512V38.7573C34.5726 35.9312 40 28.6005 40.0001 20.0011Z"
        fill="#D80027"
      />
      <path
        d="M0 20.001C0 28.6004 5.4275 35.9311 13.0434 38.7571L13.0434 1.24512C5.4275 4.0709 0 11.4017 0 20.001H0Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112214">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default RomaniaSvg;
